import React from 'react'
import PropTypes from 'prop-types'
import { Box, ButtonBase, Stack, Typography } from '@mui/material'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
// G12: el icono de DOCUMENTO de MIC, el mismo que el botón de #148 (no el clip del mock).
import DescriptionIcon from '@mui/icons-material/Description'
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined'
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import { useSmartTranslation } from '../../../../../../generic/hooks/useSmartTranslation'
import { JOB_DETAIL_TAB } from '../../utils/jobDetailTabs'
import { OVERLINE_SX } from './JobDetailPrimitives'

// Historia 160 (RN24-RN27, mock 1) — la lista lateral "BLOQUES". Pinta SOLO las pestañas visibles
// que le llegan (la decisión es `visibleTabs`) y el badge de aviso en Incidencias.

export const TAB_LABEL_KEY = {
  [JOB_DETAIL_TAB.GENERAL]: 'General',
  [JOB_DETAIL_TAB.DOCUMENTS]: 'Documents',
  [JOB_DETAIL_TAB.MATERIALS]: 'Materials',
  [JOB_DETAIL_TAB.INSPECTIONS]: 'Inspections',
  [JOB_DETAIL_TAB.INCIDENCES]: 'Incidences',
  [JOB_DETAIL_TAB.PARTS]: 'Associated parts'
}

const TAB_ICON = {
  [JOB_DETAIL_TAB.GENERAL]: InsertDriveFileOutlinedIcon,
  [JOB_DETAIL_TAB.DOCUMENTS]: DescriptionIcon,
  [JOB_DETAIL_TAB.MATERIALS]: LayersOutlinedIcon,
  [JOB_DETAIL_TAB.INSPECTIONS]: FactCheckOutlinedIcon,
  [JOB_DETAIL_TAB.INCIDENCES]: WarningAmberRoundedIcon,
  [JOB_DETAIL_TAB.PARTS]: Inventory2OutlinedIcon
}

const JobDetailBlockNav = ({ tabs = [], activeTab = JOB_DETAIL_TAB.GENERAL, openIncidences = 0, onSelect = () => {} }) => {
  const { t_ } = useSmartTranslation()
  return (
    <Box component='nav' aria-label={t_('Blocks')} sx={{ px: 1.5, py: 2 }} data-testid='job-detail-blocks'>
      <Typography component='h3' sx={{ ...OVERLINE_SX, px: 1.5, mb: 1.5 }}>{t_('Blocks')}</Typography>
      <Stack spacing={0.75} role='tablist' aria-orientation='vertical'>
        {tabs.map((tab) => {
          const Icon = TAB_ICON[tab]
          const active = tab === activeTab
          return (
            <ButtonBase
              key={tab}
              role='tab'
              aria-selected={active}
              data-testid={'block-tab-' + tab}
              onClick={() => onSelect(tab)}
              sx={{
                justifyContent: 'flex-start',
                gap: 1.5,
                px: 2,
                minHeight: 52,
                borderRadius: 2,
                border: 1,
                borderColor: active ? 'primary.main' : 'transparent',
                bgcolor: active ? 'rgba(127, 225, 167, 0.12)' : 'transparent',
                color: active ? 'primary.main' : 'text.primary'
              }}
            >
              <Icon fontSize='small' />
              <Typography sx={{ fontSize: '1.1rem', fontWeight: active ? 800 : 500, flexGrow: 1, textAlign: 'left' }}>{t_(TAB_LABEL_KEY[tab])}</Typography>
              {tab === JOB_DETAIL_TAB.INCIDENCES && openIncidences > 0
                ? <WarningAmberRoundedIcon fontSize='small' sx={{ color: 'error.light' }} data-testid='incidences-badge' />
                : null}
            </ButtonBase>
          )
        })}
      </Stack>
    </Box>
  )
}

JobDetailBlockNav.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
  activeTab: PropTypes.string,
  openIncidences: PropTypes.number,
  onSelect: PropTypes.func
}

export default React.memo(JobDetailBlockNav)
